import type { Material, MaterialKind, MaterialStatus } from '@/services/materials'

export type MaterialListKpis = {
  total: number
  active: number
  inactive: number
  raw: number
  aux: number
}

export function computeMaterialListKpis(rows: Material[]): MaterialListKpis {
  let active = 0
  let inactive = 0
  let raw = 0
  let aux = 0
  for (const r of rows) {
    if (r.status === 'active') active += 1
    else if (r.status === 'inactive') inactive += 1
    if (r.kind === 'RAW') raw += 1
    else if (r.kind === 'AUX') aux += 1
  }
  return { total: rows.length, active, inactive, raw, aux }
}

export function countMaterialsByStatus(
  rows: Material[],
  status: MaterialStatus,
): number {
  return rows.filter((r) => r.status === status).length
}

export function countMaterialsByKind(
  rows: Material[],
  kind: MaterialKind,
): number {
  return rows.filter((r) => r.kind === kind).length
}
